// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import NoSmoking from '../_raw/service/icon_no_smoking.svg';
import withIconProps from '../withIconProps';

export default withIconProps(NoSmoking);
